import React from "react";


export default (props) => {
  return [
    {
      id: 'cart',
      name: 'cart',
      color: 'tusabad',
      className: 'tusabad',

    },
    {
      id: 'checkout',
      name: 'checkout',
      color: 'tucheckout'

    },
    {
      id: 'processing',
      name: 'processing',
      color: 'warn'

    },
    {
      id: 'indoing',
      name: 'indoing',
      color: 'confirmshode'

    },
    {
      id: 'makingready',
      name: 'makingready',
      color: 'amadesazi'

    },
    {
      id: 'inpeyk',
      name: 'inpeyk',
      color: 'ersalshode'

    },
    {
      id: 'complete',
      name: 'complete',
      color: 'succ'

    },
    {
      id: 'cancel',
      name: 'cancel',
      color: 'erro'

    }
  ];
};
